import { memo, type PropsWithChildren } from 'react';
import styled from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import { translate } from '@wecasa/i18n';

import type { WithClassNameProps } from '@wecasa/web-ui/src/components/types';
import { DESKTOP_GRID_WIDTH, LEFT_CONTAINER_MD_WIDTH } from '@wecasa/web-ui/src/constants/layout';
import { boxShadow, minWidth } from '@wecasa/web-ui/src/styles/mixins';

const t = translate('components.navigation_container');

const Container = styled.div.attrs({
  role: 'navigation',
})`
  display: flex;
  justify-content: center;
  align-items: baseline;
  width: 100%;
`;

const DesktopContainer = styled(Container)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${colors.white100};
  ${boxShadow.normal};
  padding: ${toRem(10)} 0;
  margin-top: 0;

  button {
    min-width: ${toRem(250)};
  }
`;

const ButtonContainer = styled.div<{
  $showBasket: boolean;
}>`
  width: 100%;
  display: flex;
  justify-content: ${({ $showBasket }) => ($showBasket ? 'flex-start' : 'center')};

  ${minWidth.xl`
    width: ${toRem(DESKTOP_GRID_WIDTH)};
  `};
`;

const ButtonStickyWrapper = styled.div`
  width: ${LEFT_CONTAINER_MD_WIDTH};
  display: flex;
  justify-content: center;
`;

type DesktopNavigationProps = WithClassNameProps &
  PropsWithChildren<{
    showBasket?: boolean;
  }>;

const DesktopNavigation = ({ showBasket = true, children, className }: DesktopNavigationProps) => (
  <DesktopContainer aria-label={t('.label')} className={className}>
    <ButtonContainer $showBasket={showBasket}>
      <ButtonStickyWrapper>{children}</ButtonStickyWrapper>
    </ButtonContainer>
  </DesktopContainer>
);
export default memo(DesktopNavigation);
